import { jsx } from "react/jsx-runtime";
import { isWeb } from "@tamagui/core";
import { XStack } from "@tamagui/stacks";
import React from "react";
function Grid({ children, columns, itemMinWidth = 200, gap }) {
  if (isWeb) {
    return /* @__PURE__ */ jsx(
      "div",
      {
        style: {
          gap,
          display: "grid",
          justifyContent: "stretch",
          // gridTemplateRows: 'repeat(4, 1fr)',
          gridTemplateColumns: `repeat( auto-fit, minmax(${itemMinWidth}px, 1fr) )`
          // gridTemplateColumns: '1fr 1fr',
        },
        children
      }
    );
  }
  const childrenList = React.Children.toArray(children);
  return /* @__PURE__ */ jsx(XStack, { alignItems: "center", justifyContent: "center", flexWrap: "wrap", children: childrenList.map((child, i) => {
    if (!child) {
      return null;
    }
    return /* @__PURE__ */ jsx(
      XStack,
      {
        flex: 1,
        minWidth: itemMinWidth,
        marginRight: gap,
        marginBottom: gap,
        children: child
      },
      i
    );
  }) });
}
export {
  Grid
};
//# sourceMappingURL=Grid.js.map
